import React from "react";
import { NavLink } from "react-router-dom";
import Icon from "../assets/icons/Icon";

const BottomMenu = () => {
  return (
    <div className="menu_bottom ">
      <NavLink
        className={({ isActive }) =>
          `bottom-menu-icon-main ${isActive ? "active" : ""}`
        }
        to="/live-market"
      >
        <Icon name="LineChart" className="menu_icon" />
        <span>live Market</span>
      </NavLink>
      <NavLink
        className={({ isActive }) =>
          `bottom-menu-icon-main ${isActive ? "active" : ""}`
        }
        to="/badla-rate"
      >
        <Icon name="PieChart" className="menu_icon" />
        <span>Badla Rate</span>
      </NavLink>
      <NavLink
        className={({ isActive }) =>
          `bottom-menu-icon-main ${isActive ? "active" : ""}`
        }
        to="/manage-badla"
      >
        <Icon name="BarChart3" className="menu_icon" />
        <span>Manage Badla</span>
      </NavLink>
    </div>
  );
};

export default BottomMenu;
